/**
 * Hardcoded official company names by site number.
 * 1 Worldshine International (Gaithersburg)
 * 2 Worldshine Care (Beltsville)
 * 3 Worldshine Cloverleaf (Frederick)
 * Keep in sync with app/constants/siteDisplayNames.js (server).
 */
export const SITE_DISPLAY_NAMES = Object.freeze({
  1: "Worldshine International",
  2: "Worldshine Care",
  3: "Worldshine Cloverleaf",
});

export const getSiteDisplayName = (siteNum) => {
  const n = Number(siteNum);
  if (n === 1) return SITE_DISPLAY_NAMES[1];
  if (n === 2) return SITE_DISPLAY_NAMES[2];
  if (n === 3) return SITE_DISPLAY_NAMES[3];
  if (!Number.isFinite(n)) return "Worldshine";
  return `Worldshine Site ${n}`;
};
